import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SOURCE_ADMIN_SMS, SOURCE_RCS } from '@rsos/constants/locationSources';
import { addConversation } from '@rsos/reduxDataStore/src/features/conversations/conversationsSlice';
import { addRCSConversation } from '@rsos/reduxDataStore/src/features/rcs/rcsSlice';
import { addLocToQueue } from '../../../actions';
import useHasAccessToAdminLineRequests from '../../../hooks/useHasAccessToAdminLineRequests';

const CONVERSATION_START = 'conversation.start';

const normalizeLocation = (body: any) => {
  return {
    caller_id: body.caller_id,
    call_start_time: body.conversation_start_time,
    source: body.source,
    ...body?.location_data,
  };
};

const useHandleConversationMessage = () => {
  const StreamWS = window?.__RSOS?.streamWS?.instance;
  const dispatch = useDispatch();
  const hasAdminLineRequests = useHasAccessToAdminLineRequests();

  const handleConversationMessage = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (message: any) => {
      if (message?.type === CONVERSATION_START) {
        const body = message.body;
        const source = body.source;
        const isUnAuthAdmin =
          source === SOURCE_ADMIN_SMS && !hasAdminLineRequests;

        if (isUnAuthAdmin) {
          return;
        }

        const normalizedLocation = normalizeLocation(body);
        dispatch(addLocToQueue(normalizedLocation));

        // RCS uses its own chatbox
        if (source !== SOURCE_RCS) {
          dispatch(addConversation(body));
        } else {
          dispatch(addRCSConversation(body.session_metadata));
        }
      }
    },
    [dispatch, hasAdminLineRequests],
  );

  useEffect(() => {
    if (StreamWS) {
      StreamWS.addOnMessageCallback({
        handleConversationMessage: handleConversationMessage,
      });

      return () => {
        StreamWS.removeOnMessageCallback('handleConversationMessage');
      };
    }
  }, [StreamWS, handleConversationMessage]);
};

export default useHandleConversationMessage;
